import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { localStorageKeys } from '../utils/tokens';
import en from './en.json';
import no from './no.json';
import sv from './sv.json';

export const configi18next = (): unknown => {
  i18next.use(initReactI18next).init({
    ns: ['translation'],
    defaultNS: 'translation',
    lng: (
      localStorage.getItem(localStorageKeys.language) || 'en'
    ).toLowerCase(),
    fallbackLng: 'en',
    resources: {
      en: {
        translation: {
          ...en,
        },
      },
      no: {
        translation: {
          ...no,
        },
      },
      sv: {
        translation: {
          ...sv,
        },
      },
    },
  });

  return i18next;
};
